import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e45d535"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "please select one or more quokka targets from the list", -1))
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex-column" }
const _hoisted_6 = { class: "flex mt-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Title :", -1))
const _hoisted_8 = { class: "flex flex-column" }
const _hoisted_9 = { class: "grid-stack" }
const _hoisted_10 = ["gs-id", "gs-x", "gs-y", "gs-w", "gs-h"]

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import SpeedDial from "primevue/speeddial";
import CanvasCard from "@/components/CanvasCard.vue";
import { useCanvasStore } from "@/store/canvas.store";
import { storeToRefs } from "pinia";
import { GridStack } from "gridstack";
import "gridstack/dist/h5/gridstack-dd-native";
import "gridstack/dist/jq/gridstack-dd-jqueryui";
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import {
  CanvasResponse,
  CombinedTargetResponse,
  CombinedTargetSourceType,
  CreateCanvasDto,
  RelocateCanvasDto,
  TargetResponse,
  TargetSourceType,
} from "@evolutivelabs/quokka-common";
import { useTargetStore } from "@/store/target.store";
import { useCombinedTargetStore } from "@/store/combinedTarget.store";

type GenericTarget = (TargetResponse | CombinedTargetResponse) & {
  isCombined: boolean;
};
type ExtendCreateCanvasDto = CreateCanvasDto & {
  targetSources: (TargetSourceType & Pick<TargetResponse, "title" | "value">)[];
  combinedTargetSources: (CombinedTargetSourceType &
    Pick<CombinedTargetResponse, "title" | "value">)[];
};


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const canvasStore = useCanvasStore();
const { canvases } = storeToRefs(canvasStore);
const readOnlyCanvases = computed<CanvasResponse[]>(() => canvases.value);

let grid: GridStack;
const minWidthForDashboard = 500;

onMounted(async () => {
  await canvasStore.fetch();
  const isMobile = navigator.userAgentData?.mobile ?? false;
  grid = GridStack.init({
    alwaysShowResizeHandle: false,
    float: !isMobile,
    disableDrag: isMobile || window.innerWidth <= minWidthForDashboard,
    disableResize: isMobile || window.innerWidth <= minWidthForDashboard,
    cellHeight: "50px",
    margin: "8px",
    minWidth: minWidthForDashboard,
  });
  // 監聽 drop & resize 之數值
  grid.on("change", async (event, targets) => {
    if (isMobile || window.innerWidth <= minWidthForDashboard) return;
    if (!Array.isArray(targets)) return;
    const result: RelocateCanvasDto[] = [];
    targets.forEach((t) => {
      if (
        typeof t.id === "string" &&
        typeof t.x === "number" &&
        typeof t.y === "number" &&
        typeof t.w === "number" &&
        typeof t.h === "number"
      )
        result.push({
          id: t.id,
          positionX: t.x,
          positionY: t.y,
          width: t.w,
          height: t.h,
        });
    });
    try {
      await canvasStore.relocate(result);
    } catch {
      console.log("UPDATE ERROR");
    }
    window.addEventListener("resize", resizeFunc);
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeFunc);
});

const resizeFunc = () => {
  if (window.innerWidth <= minWidthForDashboard) grid.disable();
  else grid.enable();
};

const deleteCanvas = async (event: Event, id: string) => {
  try {
    // 在 backend data 中刪除
    await canvasStore.remove(id);
    // 在 grid 中刪除
    if (event.target instanceof HTMLElement) {
      const element =
        event.target?.parentElement?.parentElement?.parentElement
          ?.parentElement;
      if (element instanceof HTMLElement) {
        grid.removeWidget(element);
      }
    }
  } catch {
    console.log("DELETE ERROR");
  }
};

const targetStore = useTargetStore();
const { targets } = storeToRefs(targetStore);
const combinedTargetStore = useCombinedTargetStore();
const { combinedTargets } = storeToRefs(combinedTargetStore);
const genericTargets = computed<GenericTarget[]>(() => [
  ...targets.value.map((t) => ({ ...t, isCombined: false })),
  ...combinedTargets.value.map((t) => ({ ...t, isCombined: true })),
]);
const displayModal = ref<boolean>(false);
async function openModal() {
  await Promise.all([targetStore.fetch(), combinedTargetStore.fetch()]);
  displayModal.value = true;
}
function resetModal() {
  displayModal.value = false;
  createCanvasDto.value = buildCreateCanvasDto();
}

function buildCreateCanvasDto(): ExtendCreateCanvasDto {
  return {
    ...new CreateCanvasDto(),
    title: "untitled",
    width: 3,
    height: 5,
    targetSources: [],
    combinedTargetSources: [],
  };
}
const createCanvasDto = ref<ExtendCreateCanvasDto>(buildCreateCanvasDto());

function editSelectedItems(item: GenericTarget) {
  const targetsToEdit = item.isCombined
    ? createCanvasDto.value.combinedTargetSources
    : createCanvasDto.value.targetSources;

  const indexOfExistItem = targetsToEdit.findIndex((e) => e.id === item.id);
  if (indexOfExistItem !== -1) {
    targetsToEdit.splice(indexOfExistItem, 1);
  } else {
    targetsToEdit.push({
      id: item.id,
      displayName: "",
      title: item.title,
      value: item.value,
    });
  }
}

const previewCanvasResponse = computed<CanvasResponse>(() => {
  const dto = createCanvasDto.value;

  return {
    ...dto,
    id: "",
    targets: targets.value
      .filter((t) => dto.targetSources.some((ts) => ts.id === t.id))
      .map((t) => ({
        ...t,
        displayName:
          dto.targetSources.find((ts) => ts.id === t.id)?.displayName ?? "",
      })),
    combinedTargets: combinedTargets.value
      .filter((t) => dto.combinedTargetSources.some((ts) => ts.id === t.id))
      .map((t) => ({
        ...t,
        displayName:
          dto.combinedTargetSources.find((ts) => ts.id === t.id)?.displayName ??
          "",
      })),
  };
});

const canvasGridStack = ref<HTMLElement>();
function boundGridStack(el: unknown) {
  if (el instanceof HTMLElement) canvasGridStack.value = el;
}

async function addCanvas() {
  try {
    await canvasStore.create(createCanvasDto.value);
    await nextTick();
    if (canvasGridStack.value !== undefined) {
      grid.makeWidget(canvasGridStack.value);
    }
    displayModal.value = false;
  } catch {
    console.log("CREATE ERROR");
  }
}
function isItemExistInSelectedItems(item: GenericTarget): boolean {
  return (
    createCanvasDto.value.combinedTargetSources?.some(
      (t) => t.id === item.id
    ) || !!createCanvasDto.value.targetSources?.some((t) => t.id === item.id)
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(SpeedDial), {
      class: "fixed bottom-0 right-0 m-5",
      rotateAnimation: false,
      onClick: openModal
    }),
    _createVNode(_unref(Dialog), {
      header: "Create a new canvas",
      visible: displayModal.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((displayModal).value = $event)),
      modal: true,
      onHide: resetModal
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(Button), {
          label: "Cancel",
          icon: "pi pi-times",
          onClick: resetModal,
          class: "p-button-text"
        }),
        _createVNode(_unref(Button), {
          label: "Save",
          icon: "pi pi-check",
          onClick: addCanvas,
          autofocus: ""
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(CanvasCard, {
                  "canvas-item": _unref(previewCanvasResponse),
                  "is-deletable": false
                }, null, 8, ["canvas-item"]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_unref(InputText), {
                    type: "text",
                    modelValue: createCanvasDto.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createCanvasDto.value.title) = $event)),
                    placeholder: "title"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode(_unref(DataTable), {
                  class: "table-container",
                  value: [
                ...createCanvasDto.value.targetSources,
                ...createCanvasDto.value.combinedTargetSources,
              ],
                  responsiveLayout: "scroll"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Column), {
                      field: "title",
                      header: "Source"
                    }),
                    _createVNode(_unref(Column), {
                      field: "value",
                      header: "Value"
                    }),
                    _createVNode(_unref(Column), {
                      field: "displayName",
                      header: "Alias"
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode(_unref(InputText), {
                          type: "text",
                          modelValue: data.displayName,
                          "onUpdate:modelValue": ($event: any) => ((data.displayName) = $event),
                          placeholder: "alias"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(genericTargets), (target) => {
                  return (_openBlock(), _createBlock(_unref(Button), {
                    class: _normalizeClass(["my-1 ml-3 h-3rem", 
                isItemExistInSelectedItems(target) ? '' : 'p-button-outlined'
              ]),
                    key: target.id,
                    onClick: ($event: any) => (editSelectedItems(target))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h1", null, _toDisplayString(target.title), 1),
                      _createElementVNode("h5", null, _toDisplayString(target.unit) + " " + _toDisplayString(target.value), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(readOnlyCanvases), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          ref: boundGridStack,
          class: "grid-stack-item",
          key: item.id,
          "gs-id": item.id,
          "gs-x": item.positionX,
          "gs-y": item.positionY,
          "gs-w": item.width,
          "gs-h": item.height
        }, [
          _createVNode(CanvasCard, {
            class: "grid-stack-item-content",
            "canvas-item": item,
            onDeleteRequest: deleteCanvas,
            "is-deletable": true
          }, null, 8, ["canvas-item"])
        ], 8, _hoisted_10))
      }), 128))
    ])
  ], 64))
}
}

})